/**
 * Eine neue Version still nachladen, wenn niemand etwas verliert.
 * (25.09.2026, Martin: „App soll neue Version still nachladen.")
 *
 * Anlass: Albert lief am 24.09. stundenlang auf pre.3277, obwohl die Fixes
 * für sein abgehacktes Vorlesen (pre.3281/3282) längst ausgeliefert waren.
 * Die Pille „Neue Version" stand da — getippt hat sie niemand.
 *
 * ⚠️ Am 25.07. wurde ein automatisches Neuladen schon einmal entfernt: es
 *    riss laufende Arbeit ab. Darum hier die Umkehrung: geladen wird NUR,
 *    wenn die Seite VERDECKT ist (niemand sieht das Neuladen) und NICHTS
 *    läuft, was dabei verloren ginge. Ein einziger Grund dagegen genügt.
 */
export interface StillZustand {
  /** Liegt eine neuere Version auf dem Server? */
  updateBereit: boolean;
  /** Ist die Seite gerade sichtbar? */
  sichtbar: boolean;
  /** Läuft ein Anruf? */
  anruf: boolean;
  /** Klingt gerade etwas (Vorlesen, Spur, Musik)? */
  ton: boolean;
  /** Nimmt die Sprechtaste auf oder sendet sie? */
  sprechtaste: boolean;
  /** Hält die Seite ein Mikrofon (Tagesaufnahme im Browser, Warm-Mikro)? */
  mikro: boolean;
  /** Läuft eine Antwort (Zug offen)? */
  antwort: boolean;
  /** Steht ungesendeter Text im Eingabefeld? */
  entwurf: boolean;
}

/** Warum (noch) nicht still geladen wird — `null` heißt: jetzt laden. */
export function stillNachladenHindernis(z: StillZustand): string | null {
  if (!z.updateBereit) return "keine neue version";
  if (z.sichtbar) return "sichtbar";
  if (z.anruf) return "anruf";
  if (z.ton) return "ton";
  if (z.sprechtaste) return "sprechtaste";
  if (z.mikro) return "mikro";
  if (z.antwort) return "antwort";
  if (z.entwurf) return "entwurf";
  return null;
}

/**
 * Die Protokollzeile zum stillen Nachladen (Ticket 2653). Wartet nur ein neuer
 * Worker und liegt keine neuere Version auf dem Server, stand hier früher
 * „auf " und nichts — so sah der Kreislauf im Journal aus.
 */
export function stillNachladenZeile(anlass: string, version: string): string {
  return `[update] still nachgeladen (${anlass}) auf ${version || "neuer Worker"}`;
}
